import apiClient from './ApiClient'
//console.log(apiClient)

export default {
  login(credentials) {
    return apiClient.post('/login', credentials)
  },
  logout() {
    return apiClient.put('/logout')
  },
  // za test samo
  authCheck() {
    return apiClient.get('/test/auth')
  }
}
